import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-88" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-89" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-90" data-mp="4njnu5x67n8v">
          SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontWeight: "800"
      }} data-id="element-91" data-mp="s9zzhikkb8n9">
          Padroneggia il Coreano fluentemente in 60 Minuti
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px"
      }} data-id="element-92" data-mp="3czfms3kkof85">
          IMPARA A LEGGERE L'HANGEUL DA ZERO CON UN METODO VISIVO
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-93" data-mp="3o7vhbcfrj9tl">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-94" data-mp="30hhnphhj52ww" />
          <img src="https://cdn.magicpatterns.com/uploads/hCgZg6tCPfm7tPtYX9v68q/ChatGPT_Image_9_sept_2026,_18_18_54.png" alt="Coreano Expresso — ebook più 5 bonus in formato digitale" width={1500} height={1000} className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-contain" data-id="element-95" data-mp="35aausc0h0nc5" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-96" data-mp="2hlj7nz1qmv68">
          ⭐ 4.9 (500+ studenti soddisfatti) · ⚡ Accesso istantaneo
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-97" data-mp="iboywmxo6qvf">
          <CTAButton href="#value" data-id="element-98" data-mp="ia5jeyju8jup">Scopri il pack Coreano Expresso</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-99" data-mp="deq6c8tnmrzc">
            Inizia a capire il coreano da zero, anche se non hai mai studiato lingue prima. Impara
            l'Hangeul, frasi reali, il vocabolario essenziale e le espressioni dei K-Drama / K-Pop
            con un metodo visivo, semplice e organizzato.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-100" data-mp="x1ec5gj1elc2">
            Hangeul · Pronuncia · Vocabolario · Espressioni K-Drama · Sistema Sigma Smart
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-101" data-mp="1x7hw9eyk651e">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-102" data-mp="268y53i9q5z3i">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-103" data-mp="2g0c0peyk2erd" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-104" data-mp="2kxublaw4v420">
            Ebook + 5 bonus · 120+ pagine — Tutto ciò che ti serve in un unico posto.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-105" data-mp="2u03mi1vbczfx">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-106" data-mp="zlapbyes80lv">
              <Icon className="h-4 w-4 text-grape" data-id="element-107" data-mp="zndq9dhh3e5d" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-108" data-mp="3vhp61z9d0gr1">
          🔥 Offerta a tempo limitato · Poi il prezzo torna a 54€
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-109" data-mp="3cp33kw3y5rxh">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-110" data-mp="3rhwq31hmz8bn" />
          27 persone stanno guardando questo prodotto in questo momento
        </p>
      </div>
    </header>;
}